import { createContext } from 'react';

export interface CardStackContextValue {
  openPosition: number,
  updateOpenPosition: (position: number) => VoidFunction,
}

const CardStackContext = createContext<CardStackContextValue>({
  openPosition: undefined,
  updateOpenPosition: () => () => { },
});

export default CardStackContext;
